var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('a',{staticClass:"mr-auto",attrs:{"href":"/"}},[_c('img',{attrs:{"src":require('images/logo.png'),"alt":"Reeracoen Freelance Recruiting Business"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }